export default __webpack_public_path__ + "static/media/black-linen.8a1abc77.png";